import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=ddacdca8&scoped=true"
import script from "./OrderReview.vue?vue&type=script&lang=ts"
export * from "./OrderReview.vue?vue&type=script&lang=ts"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=ddacdca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddacdca8",
  null
  
)

export default component.exports